import { useSelector } from "react-redux";

const PageInfoBar = ({ currentNo, totalNo }) => {
  const { mode } = useSelector((state) => state.ui);
  // [판정 보강] redux mode는 과거 상태가 남아 폰에서 70px 바가 그려질 수 있음
  // → 실측 폭 판정과 OR (다른 컴포넌트들과 동일 규칙)
  const isMobile =
    mode === "mobile" ||
    Math.min(window.innerWidth, window.screen.width) <= 768;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        height: isMobile ? "40px" : "70px",
        fontSize: isMobile ? "12px" : "16px",
        width: "100vw",
        backgroundColor: "#F6F8FA", // 바 색상
        color: "#737373",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {currentNo} / {totalNo}
    </div>
  );
};

export default PageInfoBar;
